var _style, _defs, _path, _defs2, _rect, _defs3, _path2, _defs4, _polygon, _defs5, _path3, _defs6, _polygon2, _defs7, _path4, _defs8, _path5, _defs9, _path6, _defs10, _path7, _defs11, _path8, _defs12, _path9, _defs13, _path10, _defs14, _path11, _defs15, _path12, _defs16, _path13, _defs17, _polygon3, _defs18, _path14, _defs19, _polygon4, _defs20, _path15, _defs21, _path16, _defs22, _path17, _defs23, _path18, _defs24, _polygon5, _defs25, _polygon6, _defs26, _polygon7, _defs27, _path19, _defs28, _path20, _defs29, _polygon8, _defs30, _path21, _defs31, _path22, _defs32, _path23, _defs33, _rect2, _defs34, _polygon9, _defs35, _path24, _defs36, _polygon10, _defs37, _polygon11, _defs38, _path25, _defs39, _path26, _defs40, _polygon12, _defs41, _path27, _defs42, _polygon13, _defs43, _path28, _defs44, _path29, _defs45, _path30, _defs46, _path31, _defs47, _polygon14, _defs48, _polygon15, _defs49, _polygon16, _defs50, _path32, _defs51, _path33, _defs52, _polygon17, _defs53, _path34, _defs54, _path35, _defs55, _path36, _defs56, _rect3, _defs57, _polygon18, _defs58, _path37, _defs59, _polygon19, _defs60, _polygon20, _defs61, _path38, _defs62, _path39, _defs63, _path40, _defs64, _path41, _defs65, _path42, _defs66, _polygon21, _defs67, _path43, _defs68, _path44, _defs69, _path45, _defs70, _path46, _defs71, _path47, _defs72, _path48, _defs73, _path49, _defs74, _path50, _defs75, _path51, _defs76, _path52, _defs77, _polygon22, _defs78, _path53, _defs79, _path54, _defs80, _path55, _defs81, _polygon23, _defs82, _path56, _defs83, _path57, _defs84, _path58, _defs85, _path59, _defs86, _path60, _defs87, _polygon24, _defs88, _path61, _defs89, _path62, _defs90, _path63, _defs91, _polygon25, _defs92, _path64, _defs93, _polygon26;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "397px",
    height: "572px",
    viewBox: "-793 256.6 397 572",
    style: {
      enableBackground: "new -793 256.6 397 572"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);fill:#FFFFFF;}\n\t.st1{clip-path:url(#SVGID_4_);}\n\t.st2{clip-path:url(#SVGID_6_);fill:#FFFFFF;}\n\t.st3{clip-path:url(#SVGID_8_);fill:url(#SVGID_9_);}\n\t.st4{clip-path:url(#SVGID_11_);fill:#FBC143;}\n\t.st5{clip-path:url(#SVGID_13_);fill:url(#SVGID_14_);}\n\t.st6{clip-path:url(#SVGID_16_);fill:#FFFFFF;}\n\t.st7{clip-path:url(#SVGID_18_);fill:#010202;}\n\t.st8{clip-path:url(#SVGID_20_);fill:#FFFFFF;}\n\t.st9{clip-path:url(#SVGID_22_);fill:#FFFFFF;}\n\t.st10{clip-path:url(#SVGID_24_);fill:#FFFFFF;}\n\t.st11{clip-path:url(#SVGID_26_);fill:#FBC143;}\n\t.st12{clip-path:url(#SVGID_28_);fill:#020203;}\n\t.st13{clip-path:url(#SVGID_30_);fill:#020203;}\n\t.st14{clip-path:url(#SVGID_32_);fill:#FFFFFF;}\n\t.st15{clip-path:url(#SVGID_34_);fill:#FFFFFF;}\n\t.st16{clip-path:url(#SVGID_36_);fill:#010202;}\n\t.st17{clip-path:url(#SVGID_38_);fill:#010202;}\n\t.st18{clip-path:url(#SVGID_40_);fill:#010202;}\n\t.st19{clip-path:url(#SVGID_42_);fill:#010202;}\n\t.st20{clip-path:url(#SVGID_44_);fill:#010202;}\n\t.st21{clip-path:url(#SVGID_46_);fill:#010202;}\n\t.st22{clip-path:url(#SVGID_48_);fill:#010202;}\n\t.st23{clip-path:url(#SVGID_50_);fill:#010202;}\n\t.st24{clip-path:url(#SVGID_52_);fill:#010202;}\n\t.st25{clip-path:url(#SVGID_54_);fill:#010202;}\n\t.st26{clip-path:url(#SVGID_56_);fill:#010202;}\n\t.st27{clip-path:url(#SVGID_58_);fill:#010202;}\n\t.st28{clip-path:url(#SVGID_60_);fill:#010202;}\n\t.st29{clip-path:url(#SVGID_62_);fill:#010202;}\n\t.st30{clip-path:url(#SVGID_64_);fill:#010202;}\n\t.st31{clip-path:url(#SVGID_66_);fill:#010202;}\n\t.st32{clip-path:url(#SVGID_68_);fill:#010202;}\n\t.st33{clip-path:url(#SVGID_70_);fill:#010202;}\n\t.st34{clip-path:url(#SVGID_72_);fill:#010202;}\n\t.st35{clip-path:url(#SVGID_74_);fill:#010202;}\n\t.st36{clip-path:url(#SVGID_76_);fill:#010202;}\n\t.st37{clip-path:url(#SVGID_78_);fill:#010202;}\n\t.st38{clip-path:url(#SVGID_80_);fill:#010202;}\n\t.st39{clip-path:url(#SVGID_82_);fill:#010202;}\n\t.st40{clip-path:url(#SVGID_84_);fill:#010202;}\n\t.st41{clip-path:url(#SVGID_86_);fill:#010202;}\n\t.st42{clip-path:url(#SVGID_88_);fill:#010202;}\n\t.st43{clip-path:url(#SVGID_90_);fill:#010202;}\n\t.st44{clip-path:url(#SVGID_92_);fill:#010202;}\n\t.st45{clip-path:url(#SVGID_94_);fill:#010202;}\n\t.st46{clip-path:url(#SVGID_96_);fill:#010202;}\n\t.st47{clip-path:url(#SVGID_98_);fill:#010202;}\n\t.st48{clip-path:url(#SVGID_100_);fill:#010202;}\n\t.st49{clip-path:url(#SVGID_102_);fill:#010202;}\n\t.st50{clip-path:url(#SVGID_104_);fill:#010202;}\n\t.st51{clip-path:url(#SVGID_106_);fill:#010202;}\n\t.st52{clip-path:url(#SVGID_108_);fill:#010202;}\n\t.st53{clip-path:url(#SVGID_110_);fill:#010202;}\n\t.st54{clip-path:url(#SVGID_112_);fill:#010202;}\n\t.st55{clip-path:url(#SVGID_114_);fill:#010202;}\n\t.st56{clip-path:url(#SVGID_116_);fill:#010202;}\n\t.st57{clip-path:url(#SVGID_118_);fill:#010202;}\n\t.st58{clip-path:url(#SVGID_120_);fill:#010202;}\n\t.st59{clip-path:url(#SVGID_122_);fill:#010202;}\n\t.st60{clip-path:url(#SVGID_124_);fill:#010202;}\n\t.st61{clip-path:url(#SVGID_126_);fill:#010202;}\n\t.st62{clip-path:url(#SVGID_128_);fill:#010202;}\n\t.st63{clip-path:url(#SVGID_130_);fill:#010202;}\n\t.st64{clip-path:url(#SVGID_132_);fill:#010202;}\n\t.st65{clip-path:url(#SVGID_134_);fill:#010202;}\n\t.st66{clip-path:url(#SVGID_136_);fill:#010202;}\n\t.st67{clip-path:url(#SVGID_138_);fill:#010202;}\n\t.st68{clip-path:url(#SVGID_140_);fill:#010202;}\n\t.st69{clip-path:url(#SVGID_142_);fill:#010202;}\n\t.st70{clip-path:url(#SVGID_144_);fill:#010202;}\n\t.st71{clip-path:url(#SVGID_146_);fill:#010202;}\n\t.st72{clip-path:url(#SVGID_148_);fill:#010202;}\n\t.st73{clip-path:url(#SVGID_150_);fill:#010202;}\n\t.st74{clip-path:url(#SVGID_152_);fill:#010202;}\n\t.st75{clip-path:url(#SVGID_154_);fill:#010202;}\n\t.st76{clip-path:url(#SVGID_156_);fill:#010202;}\n\t.st77{clip-path:url(#SVGID_158_);fill:#010202;}\n\t.st78{clip-path:url(#SVGID_160_);fill:#010202;}\n\t.st79{clip-path:url(#SVGID_162_);fill:#010202;}\n\t.st80{clip-path:url(#SVGID_164_);fill:#010202;}\n\t.st81{clip-path:url(#SVGID_166_);fill:#010202;}\n\t.st82{clip-path:url(#SVGID_168_);fill:#010202;}\n\t.st83{clip-path:url(#SVGID_170_);fill:#010202;}\n\t.st84{clip-path:url(#SVGID_172_);fill:#010202;}\n\t.st85{clip-path:url(#SVGID_174_);fill:#010202;}\n\t.st86{clip-path:url(#SVGID_176_);fill:#010202;}\n\t.st87{clip-path:url(#SVGID_178_);fill:#010202;}\n\t.st88{clip-path:url(#SVGID_180_);fill:#010202;}\n\t.st89{clip-path:url(#SVGID_182_);fill:#010202;}\n\t.st90{clip-path:url(#SVGID_184_);fill:#010202;}\n\t.st91{clip-path:url(#SVGID_186_);fill:#010202;}\n\t.st92{clip-path:url(#SVGID_188_);fill:#010202;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-594.6,680.5l-0.4-0.2l-0.8-0.4c-0.4-0.2-46.9-25.4-88.4-70.8h-83.1h-1.6h-0.8v-0.8v-1.6v-59.8v-1.6v-0.8    h0.8h1.6h38c-6-11.9-10.9-24.1-14.6-36.3c-26.4-86.3,1.5-150.9,1.8-151.6l0.6-1.3l0.3-0.7l0.7,0.2l1.3,0.4    c0.2,0,17.7,4.6,43.3,4.6c25.2,0,63-4.6,100.1-26.3l0.8-0.5l0.4-0.2l0.4,0.2l0.8,0.5c37.1,21.7,74.9,26.3,100.1,26.3    c25.6,0,43.2-4.6,43.3-4.6l1.3-0.4l0.7-0.2l0.3,0.7l0.7,1.3c0.3,0.7,28,65.8,1.8,151.6c-3.7,12.2-8.6,24.4-14.6,36.3h41.8h1.6h0.8    v0.8v1.6v59.8v1.6v0.8h-0.8h-1.6h-87c-41.8,45.7-87.9,70.5-88.4,70.8l-0.8,0.4L-594.6,680.5z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -747.8,
    y: 281.2,
    className: "st1",
    width: 309.9,
    height: 36.1
  }))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_5_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-749.4,318.9h313.1v-39.3h-313.1V318.9z M-437.9,317.3h-309.9v-36.1h309.9V317.3z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_7_",
    d: "M-544.2,609.9c-26.8,23-50.1,34.7-50.1,34.7s-23.5-11.7-50.4-34.7H-680c41.5,44.4,85.8,67.8,85.8,67.8     s44-23.5,85.3-67.8H-544.2z M-740.1,357.8c0,0-28,63.7-1.4,149.9c4,13,9.1,25.4,15.1,36.9h24.6l0,0h213.2l0,0h26     c6-11.7,11.2-24.2,15.2-37.4c26.2-86.2-1.9-149.9-1.9-149.9s-73.9,20.1-145.4-21.7C-666.1,377.6-740.1,357.8-740.1,357.8"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: -2862.52,
    y1: -1311.6562,
    x2: -2862.3972,
    y2: -1311.6562,
    gradientTransform: "matrix(1455.286 2594.1802 -2594.1802 1455.286 762437.8125 9335092)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2572B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A3180"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "-504.3,187.7 -275.3,595.8 -685,825.7 -914,417.6   "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_10_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_11_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_10_",
    style: {
      overflow: "visible"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-595,646.2c0,0,24.5-12.2,52.3-36.4h-104.6C-619.5,634-595,646.2-595,646.2"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_12_",
    x: -767.5,
    y: 546.8,
    width: 349.3,
    height: 59.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_13_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_12_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: -2862.501,
    y1: -1311.6383,
    x2: -2862.3782,
    y2: -1311.6383,
    gradientTransform: "matrix(2999.0808 531.5071 -531.5071 2999.0808 7886948 5455693)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E20717"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BE1823"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "-756.9,486.8 -407.9,548.6 -428.8,666.7 -777.8,604.8   "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_15_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_16_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_15_",
    style: {
      overflow: "visible"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-709.3,592c4.1,4.3,9.3,6.4,15.5,6.4c6,0,11.1-2.1,15.1-6.2c4.2-4.2,6.2-9.3,6.2-15.3    c0-6.1-2.1-11.3-6.3-15.5s-9.2-6.3-15-6.3c-3.9,0-7.5,1-10.8,2.9c-3.3,2-6,4.6-7.9,7.8c-2,3.3-3,7-2.9,10.9    C-715.4,582.6-713.4,587.7-709.3,592 M-451.9,562.7c3.8,0,7,1.5,9.5,4.2c2.7,2.7,4,6,4,10c0,3.9-1.2,7.2-3.9,9.9    c-2.6,2.7-5.7,3.9-9.5,4.1c-3.3,0-6.3-1.1-8.9-3.1c-3.3-2.8-5-6.4-5-10.9c0-4.1,1.4-7.5,4-10.1C-459,564-455.8,562.7-451.9,562.7     M-519.1,555.1c-3.9,0-7.4,1-10.7,2.9c-3.4,2-6,4.6-8,7.8c-1.9,3.3-2.9,7-2.9,10.9c0,5.9,2.1,11,6.2,15.3s9.3,6.4,15.5,6.4    c5.9,0,10.9-2.1,15.1-6.2c4.1-4.2,6.2-9.3,6.2-15.3c0-6.1-2.1-11.3-6.3-15.5C-508.2,557.2-513.2,555.1-519.1,555.1 M-509.5,566.9    c2.7,2.7,4,6,4,10c0,3.9-1.3,7.2-4,9.9c-2.5,2.7-5.7,3.9-9.5,4.1c-3.3,0-6.2-1.1-8.7-3.1c-3.3-2.8-5-6.4-5-10.9    c0-4.1,1.3-7.5,4-10.1c2.5-2.7,5.7-4.1,9.6-4.1C-515.4,562.7-512.2,564.2-509.5,566.9 M-493,556.1v41.3h19.3v-7.5h-11.5V556    L-493,556.1L-493,556.1z M-752.4,565.7c-1.9,3.2-2.8,6.8-2.8,11.1c0,6.3,2,11.5,6.1,15.6c4.1,4.1,9.4,6.1,15.7,6.1    c3.5,0,6.7-0.5,9.4-1.6c2.8-1.2,5.6-3.3,8.6-6.2l-5.3-5.5c-2.3,2.2-4.3,3.8-6.2,4.5c-2,0.9-4,1.3-6.3,1.3c-2.7,0-5.1-0.5-7.3-1.7    c-2.1-1.3-3.9-3-5.1-5.1c-1.2-2.1-1.8-4.5-1.8-7.3c0-4,1.3-7.3,4-10.1c2.8-2.7,6.1-4,9.9-4c4.8,0,9,2,12.7,5.9l5.5-5.2    c-2.3-2.6-5-4.8-8.2-6.2c-3.1-1.3-6.4-2.1-9.8-2.1c-4,0-7.7,1-11.2,2.9C-747.9,560-750.6,562.5-752.4,565.7 M-430.5,576.9    c-0.1-6.1-2.2-11.3-6.4-15.5c-4.1-4.2-9.2-6.3-15-6.3c-3.9,0-7.5,1-10.8,2.9c-3.4,2-5.9,4.6-7.8,7.8c-1.9,3.3-2.9,7-2.9,10.9    c0,5.9,2,11,6.2,15.3c4.1,4.3,9.2,6.4,15.5,6.4c5.9,0,10.9-2.1,15.1-6.2C-432.6,588-430.5,582.9-430.5,576.9 M-560.4,562.7    c4.7,0,8.9,2,12.6,5.9l5.5-5.2c-2.3-2.6-5-4.8-8.2-6.2c-3.1-1.3-6.4-2.1-9.8-2.1c-4,0-7.7,1-11.2,2.9c-3.5,2-6.2,4.5-8.1,7.7    s-2.8,6.8-2.8,11.1c0,6.3,2,11.5,6.1,15.6s9.4,6.1,15.8,6.1c3.4,0,6.6-0.5,9.3-1.6c2.8-1.2,5.6-3.3,8.6-6.2l-5.3-5.5    c-2.3,2.2-4.3,3.8-6.2,4.5c-2,0.9-4,1.3-6.3,1.3c-2.7,0-5.1-0.5-7.3-1.7c-2.1-1.3-3.9-3-5.1-5.1c-1.2-2.1-1.8-4.5-1.8-7.3    c0-4,1.3-7.3,4-10.1C-567.6,564-564.3,562.7-560.4,562.7 M-604.9,576.9c-0.1-6.1-2.1-11.3-6.3-15.5s-9.3-6.3-15-6.3    c-4,0-7.5,1-10.8,2.9c-3.3,2-6,4.6-7.8,7.8c-2,3.3-3,7-2.9,10.9c-0.1,5.9,2,11,6.1,15.3c4.1,4.3,9.3,6.4,15.5,6.4    c6,0,11.1-2.1,15.1-6.2C-606.9,588-604.9,582.9-604.9,576.9 M-616.6,586.8c-2.6,2.7-5.9,3.9-9.6,4.1c-3.3,0-6.2-1.1-8.7-3.1    c-3.3-2.8-5-6.4-5-10.9c0-4.1,1.3-7.5,4-10.1c2.5-2.7,5.9-4.1,9.6-4.1c3.9,0,7,1.5,9.6,4.2c2.6,2.7,4,6,4,10    C-612.7,580.7-614.1,584-616.6,586.8 M-600.5,574h14.3v7.2h-14.3V574z M-694,562.7c3.9,0,7.1,1.5,9.6,4.2c2.6,2.7,4,6,4,10    c0,3.9-1.3,7.2-3.9,9.9c-2.6,2.7-5.9,3.9-9.6,4.1c-3.2,0-6.2-1.1-8.7-3.1c-3.2-2.8-4.9-6.4-4.9-10.9c-0.1-4.1,1.2-7.5,3.9-10.1    C-701,564-697.7,562.7-694,562.7 M-648.1,589.9h-11.4V556h-7.9v41.3h19.2v-7.4H-648.1z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_17_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_18_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_17_",
    style: {
      overflow: "visible"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M-662.1,469.1h5.8c-0.4,5.6-2.3,8.8-2.8,10c-0.8,2.1,0.2,3.3,1.1,5.3c-3.6,0.7-3.9,6.6-0.8,7.3l3.4,0.5    c1,0.4,1.2,0.9,0.9,1.6c-0.9,2.4-4.7,4.4-5.5,7.5c-0.4,1.8-0.6,4.8,0.1,6.5c1.1,2.9,4.1,5.3,8.1,5.5c10.7,0.6,13.9,0.1,21.8-0.3    c0.4,0.7,6.9,6.2,7.5,15.2c-0.1,3.5-1.5,5-2.2,5.8c-3,1.1-12.5,5.5-21.3,10.5h70.4l67.9,0.1c-0.5-1-1-2.8-0.9-4.1    c0.1-1-0.1-2-0.4-2.9c0-1.5-0.3-2.9-0.8-4.1c-0.1-1.1-1-2.4-1.3-3.9l-1.5-3.3c-0.6-1.3-1.4-2.6-2.5-3.9c-2-0.8-3.1-1.6-3.5-2.3    c-0.8-1.8-1.6-3.4-2.6-4.5c-1.3-1.3-2.1-2.4-3.8-3.8c-0.7-0.5-0.8-2.5-1.5-3.6l-1.6-2.5l-0.5-2.2c-0.3-0.7-0.7-1.4-1.1-2.3    c-0.3-0.8-0.5-1.7-0.6-2.6c-0.2-1-0.3-1.9-0.6-2.5c-0.4-0.6-0.8-1.2-1-1.9l-0.8-2.9l-0.9-3.5c-0.9-1.2-1.5-2.6-1.9-4.1    c-0.2-2.8-0.5-4.8-0.9-6l-1.6-4.3c-0.3-0.9-0.8-1.7-1.3-2.4c-1-1.3-2-2.3-2.9-3.1l-3.6-2.7c-1.7-0.8-2.8-0.5-2.9-1.3l-1.2-17.6    l-0.1-4.1c-0.4-1.4-0.8-2.3-1.1-2.8c-0.5-0.5-1.5-0.7-1.9-1.2l-0.5-2.4l-0.9-2.2l-0.1-1.8l-1.7-4.6l-2.8-5.1    c-0.1-1.8-0.2-3.3-0.6-4.5c-0.4-1.2-1.5-2.4-2.2-3.5c-0.7-1.3-1.1-2.5-1.4-3.8c-0.2-0.9-0.3-2-0.8-2.8c-0.7-0.8-1.7-1.6-2.4-2    c-1.3-0.9-2.4-1.1-3.3-1.4c-1-0.4-1.9-0.5-2.9-0.5c-1.4-0.1-3.3,0.5-3.8,0.2c-0.3-0.8-0.6-1.3-0.9-1.5c-1.5-0.6-1.8-0.1-3.8-0.5    l-2.6-1.4c-1.2,0.2-2.4-1.1-3.3-1.1c-0.7,0.2-1.8,0-2.5-0.2c-0.7-0.3-1.6-0.4-2.7-0.5c-0.3-1-0.9-1.9-1.5-2.7    c-1.1-1.2-2-1.9-2.7-2.2c-1-0.3-2-0.3-2.7-0.8c-0.6-0.4-1.3-0.8-1.9-0.9c-2.2,0.3-1.9,0.9-2.8,1.1c-1-0.2-1.7-0.8-2.3-0.7    c-1.2,0.2-1.7,0.9-2.3,1c-0.8-0.1-1.4-0.4-1.9-0.8c-1.9-0.5-2.3,0-4.2-0.2c-4-1.8-6.9-3.2-9.9-3.5c-4.3-0.7-6.9-0.9-11.2,2.1    c-2.7,2.7-4.8,6.1-6.5,10.3c-0.4,1.5-0.3,2.1,0.5,3.5c-1.7,1.5-3.1,4.6-2.6,6.4l1.5,3.2c-4.5,0.5-7.1,4-4,10.8    c-1.6,0.8-9.6,5.4-7.3,18.2c-2.7,3.5-11.1,18.5-12.5,20.9C-666.9,467.6-664.4,469.4-662.1,469.1"
  }))), /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_19_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_20_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_19_",
    style: {
      overflow: "visible"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M-561.9,428c-0.4-1.9-3-1.5-2.1-4.5c1.7-0.6,3.3,0,4.9,1.8c1.4,2.6,1.7,4.6,0.9,6.2    C-559.5,432.6-560.7,431.4-561.9,428"
  }))), /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_21_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_22_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_21_",
    style: {
      overflow: "visible"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-588.8,468.1c0.8-0.2,1.1-0.6,1.1-1.4c0.7-0.9,1.5-0.9,2.6-0.1c2.7,4.5,5.4,11,7.9,19.5    c0.3,2.2-0.3,2.8-1.6,1.6l-4.7-6.9c-1.3-1.7-2.2-0.8-2.3,0.8l0.3,3.1c-0.6,0.6-0.9,0.8-1.7,0.6c-0.8-0.2-1.4-1.3-1.9-3.4    c0-4.4-2.1-12.1-4.7-14.9c-0.7-2.4,1.4-2.6,2.2-1.3C-590.3,467.6-589.3,468.4-588.8,468.1"
  }))), /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_23_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_24_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_23_",
    style: {
      overflow: "visible"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M-636.9,404.8c2.2,0.3,6.5,2.9,12.2,5.9c0.8-0.4,2.2-0.2,4.1,0.5c10.9,5.1,17.8,8.9,20.6,11.2    c4.4,1.8,12.6,7.4,17.2,9.8c12.7,4.5,20.4,8.3,25.6,12l2.3,0.3c3.4,0.8-0.2-5.9,3.7-3.8c0.4-0.1,1,3.4,1,9.8c0.8,3,1,14,0.6,14.3    c-2.4,1.2-11-2.6-9.7,1.3l4,6.5c0.4,2.9-0.2,3.4-2.4,2.2c-2.7-4.7-5.6-9-8.6-13l-10-4.1l-22.2-13.2l-14.6-7.4l-17.3-8.4l-13.9-5.3    c-0.9-2.3-0.9-4.2,0-5.9c0.6-0.6,2.4-0.9,5.3-0.8l-2.1-5.7C-641.2,408.5-639.8,406.4-636.9,404.8"
  }))), /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_25_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_26_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_25_",
    style: {
      overflow: "visible"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M-661.9,467.9c4.3-0.1,6.6,0,7.8,0.3c1.5,1.2,3.2,0.4,3.3-0.7c0.3-0.3,1-0.4,2-0.4c2.1,0.8,3.8,7.1,2.3,7.4    c-3-2-5.7-3.1-8.3-2.8c-0.2,0.8-0.6,5.2-1.8,6.4c-1.2,1.3-1.1,2.9,0.4,4.2c2.8,0.9,5.4,1.4,8,1.5l3,0.3c1.1,1.6,0.3,5.3-0.3,4.9    c-1.6-1.6-3.8-2.7-7.1-3.4c-7.6-1.7-8.3,4.4-4.3,5.4c1.8,0.3,2.6,0.6,4.2,0.3c0.3,0.7,0.2,1.5,0.1,2.4c-0.9,3.8-5,4.8-5.8,8.7    c-0.9,6.3,2.7,8.3,5.7,9.6c6.9,1.9,33.8-1,34.7-1.3c4.2-0.9,10.6-7.3,12.5-8.9c0.9-0.6,1.7,0.1,1.3,1.7c-0.4,0.8-3.7,2-5.2,6    c-2.1,5.3-5.9,14.8-6.4,19c-0.3,1-0.2,5.4-0.4,8.9c-0.1,1.8-0.6,3.1-1.5,3.8c-0.8,0.7-1.1,1.3-2.4,0.7c-1.7-0.9-1.5-6.3-3.9-6.2    c-2.8,0.3-17.6,8.2-17.6,8.2l-1.6,0.9l98.9-0.1c-4-2.6-13.5-9-15.9-10c-2.1-0.9-2.5-0.2-3.9-0.6c-0.6-0.1-2.2-2.2-3.9-3.9    c-2-1.4-4.8-4.5-8.4-9.3c-3.4-5-4.1-9.8-5.9-10.9c-0.9-0.5-2.3-0.5-4.3,0c-1.8-11.2-4.1-17.4-7.2-17c-1.3,0.3-2.9,0.9-3.5,0.6    c-0.9,0.1-3.1-6.7-7-8.4c-0.5-1.3-0.1-2,1.2-2.1h4.5c1-2.1,1-3.4,0.2-4.1l-2.9-0.1v-8.1l-3.7-6.5c-0.1-3.9-1.2-7.6-2.8-11.3    c-5.1-7.7-9.1-13-12-15.8c-1.9-1.5-3.7-2.4-5.5-2.7c-3.5-2.5-6.2-4.1-7.9-4.7c-1.9-0.8-10-3.5-11-3.2c-2.3,0.7-8.8,4.9-7.3,16.4    c0.2,0.9-0.3,1.9-1.7,2.9c-1.9,3.7-10.5,18.6-10.5,18.6C-664.5,466.2-664,467.4-661.9,467.9"
  }))), /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_27_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_28_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_27_",
    style: {
      overflow: "visible"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M-647.8,437.1l1.1-1.3l2.6-0.1l8.3-0.6c2.3,0.5,7.2,3.6,8.4,6.6l-0.4,1.1c-1.5-1-3.2-1.7-4.2-1.6    c-0.4,0.6,0.3,4.3-0.2,3.9c-0.3,0.7-6.4-4.2-7.2-1.5c-0.8,1.4-0.2,3.5,0.5,4.6c1,2.2-1,2.2-2.9,1.7l-5.2-4L-647.8,437.1z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_29_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_30_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_29_",
    style: {
      overflow: "visible"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M-627.6,484.3c-1.4,1.8-3.1,0.2-2.2-1.9c0,0,3.3-5.3,1.6-5.9c-0.3-0.3-1.7-0.9-2-1.4    c-1.4-0.4-1.4-2.4,0.1-2.8c0.9-0.7,4.5-1.4,5.9-1.5c1.9-0.1,8.4-1,9.3,0c1.5,1.2-4.6,4-8.3,6.9    C-626,480.8-625.5,480.3-627.6,484.3"
  }))), /*#__PURE__*/React.createElement("g", null, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_31_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_32_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_31_",
    style: {
      overflow: "visible"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M-594.7,645.8c0,0-24.3-12.1-51.8-36h-3.9c28.4,25.1,53.9,38.2,54.4,38.4l1.2,0.6l1.2-0.6    c0.5-0.3,26-13.3,54.4-38.4h-3.8C-570.5,633.7-594.7,645.8-594.7,645.8 M-466,387.4l-0.8-2.2l-2.2,0.4c-0.1,0-12,2.2-29.8,2.2    c-24.6,0-61-4.1-94.6-23.8l-1.4-0.8l-1.3,0.8c-33.6,19.6-70,23.8-94.6,23.8c-17.8,0-29.7-2.2-29.8-2.2l-2.3-0.4l-0.8,2.2    c-0.7,2-17,50.4,4.8,121.6c3.9,12.7,9.1,24.6,15.1,35.6h3c-6.2-11.2-11.6-23.3-15.6-36.4c-21.8-71.2-4.8-120-4.8-120    s67.2,12.6,126.2-21.9c59,34.5,126.2,21.9,126.2,21.9s17,48.8-4.8,120c-4,13.1-9.4,25.2-15.6,36.4h3c6.1-11,11.2-22.9,15.1-35.6    C-449,437.8-465.3,389.4-466,387.4"
  }))), /*#__PURE__*/React.createElement("g", null, _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_33_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_34_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_33_",
    style: {
      overflow: "visible"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M-769.7,609.1h354.1v-64.7h-354.1V609.1z M-418.2,606.6h-349.3v-60h349.3V606.6z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_35_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_36_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_35_",
    style: {
      overflow: "visible"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "-750.7,790.8 -742.7,790.8 -742.7,791.1 -750.3,791.1 -750.3,796.5 -743.4,796.5 -743.4,796.8     -750.3,796.8 -750.3,802.4 -750.7,802.4   "
  }))), /*#__PURE__*/React.createElement("g", null, _defs18 || (_defs18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_37_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_38_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_37_",
    style: {
      overflow: "visible"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M-739.3,797.2v-6.4h0.4v6.4c0,3.3,1.8,5,4.3,5c2.6,0,4.3-1.6,4.3-4.9v-6.5h0.3v6.4c0,3.5-1.9,5.3-4.7,5.3    C-737.4,802.5-739.3,800.8-739.3,797.2"
  }))), /*#__PURE__*/React.createElement("g", null, _defs19 || (_defs19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_39_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_40_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_39_",
    style: {
      overflow: "visible"
    }
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "-725.5,790.8 -725.2,790.8 -716.4,801.8 -716.4,790.8 -716,790.8 -716,802.4 -716.4,802.4     -725.1,791.4 -725.1,802.4 -725.5,802.4   "
  }))), /*#__PURE__*/React.createElement("g", null, _defs20 || (_defs20 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_41_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_42_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_41_",
    style: {
      overflow: "visible"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M-711.4,790.8h3.7c3.6,0,6.1,2.5,6.1,5.8l0,0c0,3.2-2.5,5.8-6.1,5.8h-3.7V790.8z M-707.6,802    c3.4,0,5.8-2.4,5.8-5.4l0,0c0-3-2.4-5.4-5.8-5.4h-3.4v10.9L-707.6,802L-707.6,802z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs21 || (_defs21 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_43_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_44_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_43_",
    style: {
      overflow: "visible"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-693.6,790.7h0.3l5.6,11.6h-0.4l-1.7-3.5h-7.4l-1.6,3.5h-0.4L-693.6,790.7z M-690,798.6l-3.5-7.4l-3.5,7.4    H-690z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs22 || (_defs22 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_45_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_46_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_45_",
    style: {
      overflow: "visible"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M-684.2,790.8h3.7c3.6,0,6.1,2.5,6.1,5.8l0,0c0,3.2-2.5,5.8-6.1,5.8h-3.7V790.8z M-680.5,802    c3.4,0,5.8-2.4,5.8-5.4l0,0c0-3-2.4-5.4-5.8-5.4h-3.3v10.9L-680.5,802L-680.5,802z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs23 || (_defs23 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_47_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_48_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_47_",
    style: {
      overflow: "visible"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M-670.7,796.6L-670.7,796.6c0-3.2,2.2-6,5.7-6s5.7,2.8,5.7,6l0,0c0,3.2-2.2,6-5.7,6    C-668.4,802.6-670.7,799.7-670.7,796.6 M-659.6,796.6L-659.6,796.6c0-3-2.2-5.7-5.4-5.7s-5.4,2.6-5.4,5.6l0,0c0,3,2.2,5.6,5.4,5.6    C-661.7,802.2-659.6,799.6-659.6,796.6"
  }))), /*#__PURE__*/React.createElement("g", null, _defs24 || (_defs24 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_49_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_50_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_49_",
    style: {
      overflow: "visible"
    }
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "-649.2,790.8 -641.1,790.8 -641.1,791.1 -648.8,791.1 -648.8,796.4 -641.8,796.4 -641.8,796.7     -648.8,796.7 -648.8,802 -641,802 -641,802.4 -649.2,802.4   "
  }))), /*#__PURE__*/React.createElement("g", null, _defs25 || (_defs25 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_51_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_52_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_51_",
    style: {
      overflow: "visible"
    }
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "-637,790.8 -636.7,790.8 -636.7,802 -629.6,802 -629.6,802.4 -637,802.4   "
  }))), /*#__PURE__*/React.createElement("g", null, _defs26 || (_defs26 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_53_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_54_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_53_",
    style: {
      overflow: "visible"
    }
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "-619.2,791.1 -621.3,792.1 -621.5,791.8 -619.1,790.7 -618.8,790.7 -618.8,802.4 -619.2,802.4   "
  }))), /*#__PURE__*/React.createElement("g", null, _defs27 || (_defs27 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_55_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_56_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_55_",
    style: {
      overflow: "visible"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M-614.3,801.1l0.2-0.3c0.9,0.8,2,1.4,3.1,1.4c2.7,0,4.2-2.6,4.2-6l0,0c0-0.4,0-1,0-1.4    c-0.2,1.8-1.8,3.2-3.8,3.2c-2.3,0-4-1.5-4-3.6l0,0c0-2.1,1.7-3.7,4-3.7c1.3,0,2.2,0.5,2.9,1.2c0.9,0.9,1.4,2.3,1.4,4.4l0,0    c0,3.6-1.7,6.3-4.5,6.3C-612.2,802.6-613.4,802-614.3,801.1 M-607,794.4L-607,794.4c0-1.9-1.6-3.5-3.6-3.5s-3.6,1.6-3.6,3.4l0,0    c0,2,1.6,3.3,3.7,3.3C-608.7,797.7-607,796.2-607,794.4"
  }))), /*#__PURE__*/React.createElement("g", null, _defs28 || (_defs28 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_57_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_58_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_57_",
    style: {
      overflow: "visible"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M-596.4,790.8h3.7c3.6,0,6.1,2.5,6.1,5.8l0,0c0,3.2-2.5,5.8-6.1,5.8h-3.7V790.8z M-592.7,802    c3.4,0,5.8-2.4,5.8-5.4l0,0c0-3-2.4-5.4-5.8-5.4h-3.3v10.9L-592.7,802L-592.7,802z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs29 || (_defs29 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_59_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_60_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_59_",
    style: {
      overflow: "visible"
    }
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "-582.4,790.8 -574.3,790.8 -574.3,791.1 -582,791.1 -582,796.4 -575.1,796.4 -575.1,796.7     -582,796.7 -582,802 -574.3,802 -574.3,802.4 -582.4,802.4   "
  }))), /*#__PURE__*/React.createElement("g", null, _defs30 || (_defs30 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_61_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_62_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_61_",
    style: {
      overflow: "visible"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M-559.9,790.7h0.3l5.6,11.6h-0.4l-1.7-3.5h-7.4l-1.6,3.5h-0.4L-559.9,790.7z M-556.3,798.6l-3.5-7.4    l-3.5,7.4H-556.3z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs31 || (_defs31 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_63_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_64_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_63_",
    style: {
      overflow: "visible"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M-550.5,790.8h4.7c1.3,0,2.4,0.3,3,1c0.5,0.5,0.7,1.1,0.7,1.9l0,0c0,1.4-0.9,2.4-2.2,2.7    c1.6,0.2,2.8,1.3,2.8,2.9l0,0c0,1.9-1.5,3-4.1,3h-5L-550.5,790.8L-550.5,790.8z M-545.5,796.3c1.7,0,3.2-0.8,3.2-2.6l0,0    c0-1.6-1.3-2.6-3.4-2.6h-4.4v5.2H-545.5z M-545.5,802c2.4,0,3.8-1,3.8-2.6l0,0c0-1.7-1.6-2.7-3.5-2.7h-4.9v5.3H-545.5z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs32 || (_defs32 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_65_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_66_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_65_",
    style: {
      overflow: "visible"
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M-537.3,790.8h4.7c1.5,0,2.6,0.4,3.3,1.1c0.5,0.5,0.8,1.3,0.8,2.1l0,0c0,1.9-1.6,3.1-3.8,3.2l3.8,5h-0.4    l-3.8-5l0,0h-4.2v5h-0.4V790.8L-537.3,790.8z M-532.8,797c2.7,0,4-1.3,4-2.9l0,0c0-1.8-1.4-2.9-3.8-2.9h-4.3v5.9L-532.8,797    L-532.8,797z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs33 || (_defs33 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_67_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_68_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_67_",
    style: {
      overflow: "visible"
    }
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -524,
    y: 790.8,
    className: "st32",
    width: 0.4,
    height: 11.5
  }))), /*#__PURE__*/React.createElement("g", null, _defs34 || (_defs34 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_69_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_70_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_69_",
    style: {
      overflow: "visible"
    }
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st33",
    points: "-518.8,790.8 -518.5,790.8 -518.5,802 -511.4,802 -511.4,802.4 -518.8,802.4   "
  }))), /*#__PURE__*/React.createElement("g", null, _defs35 || (_defs35 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_71_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_72_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_71_",
    style: {
      overflow: "visible"
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M-502.1,790.8h3.7c3.6,0,6.1,2.5,6.1,5.8l0,0c0,3.2-2.5,5.8-6.1,5.8h-3.7V790.8z M-498.4,802    c3.4,0,5.8-2.4,5.8-5.4l0,0c0-3-2.4-5.4-5.8-5.4h-3.3v10.9L-498.4,802L-498.4,802z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs36 || (_defs36 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_73_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_74_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_73_",
    style: {
      overflow: "visible"
    }
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st35",
    points: "-488.1,790.8 -480,790.8 -480,791.1 -487.7,791.1 -487.7,796.4 -480.7,796.4 -480.7,796.7     -487.7,796.7 -487.7,802 -479.9,802 -479.9,802.4 -488.1,802.4   "
  }))), /*#__PURE__*/React.createElement("g", null, _defs37 || (_defs37 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_75_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_76_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_75_",
    style: {
      overflow: "visible"
    }
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st36",
    points: "-468.9,791.1 -471.1,792.1 -471.3,791.8 -468.9,790.7 -468.6,790.7 -468.6,802.4 -468.9,802.4   "
  }))), /*#__PURE__*/React.createElement("g", null, _defs38 || (_defs38 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_77_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_78_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_77_",
    style: {
      overflow: "visible"
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M-464.1,801.1l0.2-0.3c0.9,0.8,2,1.4,3.1,1.4c2.7,0,4.2-2.6,4.2-6l0,0c0-0.4,0-1,0-1.4    c-0.2,1.8-1.8,3.2-3.8,3.2c-2.3,0-4-1.5-4-3.6l0,0c0-2.1,1.7-3.7,4-3.7c1.3,0,2.2,0.5,2.9,1.2c0.9,0.9,1.4,2.3,1.4,4.4l0,0    c0,3.6-1.7,6.3-4.5,6.3C-461.9,802.6-463.2,802-464.1,801.1 M-456.8,794.4L-456.8,794.4c0-1.9-1.6-3.5-3.6-3.5s-3.6,1.6-3.6,3.4    l0,0c0,2,1.6,3.3,3.7,3.3C-458.4,797.7-456.8,796.2-456.8,794.4"
  }))), /*#__PURE__*/React.createElement("g", null, _defs39 || (_defs39 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_79_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_80_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_79_",
    style: {
      overflow: "visible"
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M-453.3,802.1l5.2-5.1c1.8-1.7,2.1-2.7,2.1-3.5c0-1.4-1.3-2.6-3.1-2.6c-1.7,0-2.9,1-3.6,2.3l-0.3-0.2    c0.8-1.4,2.1-2.5,3.9-2.5c2,0,3.4,1.3,3.4,2.9l0,0c0,1-0.3,1.9-2.2,3.8l-4.9,4.7h7.2v0.3h-7.8L-453.3,802.1L-453.3,802.1z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs40 || (_defs40 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_81_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_82_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_81_",
    style: {
      overflow: "visible"
    }
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "-751.1,802.8 -749.9,802.8 -749.9,797.2 -743,797.2 -743,796.1 -749.9,796.1 -749.9,791.5     -742.3,791.5 -742.3,790.4 -751.1,790.4   "
  }))), /*#__PURE__*/React.createElement("g", null, _defs41 || (_defs41 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_83_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_84_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_83_",
    style: {
      overflow: "visible"
    }
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M-730.7,797.3c0,2.9-1.4,4.5-3.9,4.5s-3.9-1.7-3.9-4.6v-6.8h-1.2v6.8c0,3.6,1.9,5.7,5.1,5.7    c3.2,0,5.1-2.1,5.1-5.7v-6.8h-1.2C-730.7,790.4-730.7,797.3-730.7,797.3z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs42 || (_defs42 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_85_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_86_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_85_",
    style: {
      overflow: "visible"
    }
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "-716.8,800.6 -725,790.4 -725.9,790.4 -725.9,802.8 -724.7,802.8 -724.7,792.6 -716.5,802.8     -715.6,802.8 -715.6,790.4 -716.8,790.4   "
  }))), /*#__PURE__*/React.createElement("g", null, _defs43 || (_defs43 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_87_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_88_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_87_",
    style: {
      overflow: "visible"
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M-707.6,790.4h-4.1v12.4h4.1c3.8,0,6.5-2.6,6.5-6.2C-701.1,793-703.9,790.4-707.6,790.4 M-707.6,801.6h-3    v-10.1h2.9c3.1,0,5.4,2.1,5.4,5.1C-702.3,799.5-704.5,801.6-707.6,801.6"
  }))), /*#__PURE__*/React.createElement("g", null, _defs44 || (_defs44 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_89_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_90_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_89_",
    style: {
      overflow: "visible"
    }
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M-693.9,790.3l-6,12.5h1.3l1.6-3.5h6.8l1.7,3.5h1.3l-6-12.5H-693.9z M-696.3,798.1l2.9-6l2.9,6H-696.3z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs45 || (_defs45 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_91_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_92_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_91_",
    style: {
      overflow: "visible"
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M-680.5,790.4h-4.1v12.4h4.1c3.8,0,6.5-2.6,6.5-6.2C-673.9,793-676.7,790.4-680.5,790.4 M-680.5,801.6h-3    v-10.1h2.9c3.1,0,5.4,2.1,5.4,5.1C-675.1,799.5-677.4,801.6-680.5,801.6"
  }))), /*#__PURE__*/React.createElement("g", null, _defs46 || (_defs46 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_93_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_94_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_93_",
    style: {
      overflow: "visible"
    }
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M-664.9,790.2c-3.5,0-6.2,2.7-6.2,6.4c0,3.6,2.6,6.4,6.2,6.4c3.5,0,6.2-2.7,6.2-6.4    C-658.8,792.9-661.4,790.2-664.9,790.2 M-664.9,801.8c-3.1,0-5-2.7-5-5.3c0-2.5,1.7-5.2,4.9-5.2c3.1,0,5,2.7,5,5.3    C-660,799.1-661.7,801.8-664.9,801.8"
  }))), /*#__PURE__*/React.createElement("g", null, _defs47 || (_defs47 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_95_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_96_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_95_",
    style: {
      overflow: "visible"
    }
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "-648.4,797.1 -641.4,797.1 -641.4,796 -648.4,796 -648.4,791.5 -640.7,791.5 -640.7,790.4     -649.6,790.4 -649.6,802.8 -640.6,802.8 -640.6,801.6 -648.4,801.6   "
  }))), /*#__PURE__*/React.createElement("g", null, _defs48 || (_defs48 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_97_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_98_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_97_",
    style: {
      overflow: "visible"
    }
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "st47",
    points: "-636.3,790.4 -637.4,790.4 -637.4,802.8 -629.2,802.8 -629.2,801.6 -636.3,801.6   "
  }))), /*#__PURE__*/React.createElement("g", null, _defs49 || (_defs49 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_99_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_100_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_99_",
    style: {
      overflow: "visible"
    }
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "st48",
    points: "-622,791.6 -621.5,792.6 -619.6,791.8 -619.6,802.8 -618.4,802.8 -618.4,790.3 -619.2,790.3   "
  }))), /*#__PURE__*/React.createElement("g", null, _defs50 || (_defs50 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_101_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_102_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_101_",
    style: {
      overflow: "visible"
    }
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M-610.7,790.2c-2.5,0-4.4,1.8-4.4,4.2c0,2.3,1.9,4,4.4,4c1.4,0,2.6-0.6,3.4-1.6c-0.1,2.6-1.3,5-3.7,5    c-1,0-2-0.5-2.8-1.3l-0.3-0.3l-0.8,0.9l0.3,0.3c1,1,2.3,1.6,3.6,1.6c3,0,4.9-2.7,4.9-6.7c0-2.2-0.5-3.7-1.5-4.7    C-608.3,790.6-609.4,790.2-610.7,790.2 M-610.6,797.2c-1.9,0-3.3-1.2-3.3-2.9c0-1.6,1.5-3,3.2-3c1.8,0,3.2,1.3,3.2,3.1    C-607.5,796-608.9,797.2-610.6,797.2"
  }))), /*#__PURE__*/React.createElement("g", null, _defs51 || (_defs51 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_103_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_104_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_103_",
    style: {
      overflow: "visible"
    }
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M-592.7,790.4h-4.1v12.4h4.1c3.8,0,6.5-2.6,6.5-6.2C-586.2,793-588.9,790.4-592.7,790.4 M-592.7,801.6h-3    v-10.1h2.9c3.1,0,5.4,2.1,5.4,5.1C-587.4,799.5-589.6,801.6-592.7,801.6"
  }))), /*#__PURE__*/React.createElement("g", null, _defs52 || (_defs52 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_105_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_106_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_105_",
    style: {
      overflow: "visible"
    }
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "st51",
    points: "-581.6,797.1 -574.6,797.1 -574.6,796 -581.6,796 -581.6,791.5 -573.9,791.5 -573.9,790.4     -582.8,790.4 -582.8,802.8 -573.8,802.8 -573.8,801.6 -581.6,801.6   "
  }))), /*#__PURE__*/React.createElement("g", null, _defs53 || (_defs53 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_107_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_108_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_107_",
    style: {
      overflow: "visible"
    }
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M-560.2,790.3l-6,12.5h1.3l1.6-3.5h6.8l1.7,3.5h1.3l-6-12.5H-560.2z M-562.7,798.1l2.9-6l2.9,6H-562.7z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs54 || (_defs54 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_109_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_110_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_109_",
    style: {
      overflow: "visible"
    }
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M-543,796.4c0.9-0.6,1.4-1.5,1.4-2.7c0-0.9-0.3-1.6-0.9-2.2c-0.7-0.7-1.9-1.1-3.3-1.1h-5.1v12.4h5.4    c2.8,0,4.5-1.3,4.5-3.4C-541,798-541.8,796.9-543,796.4 M-549.7,791.5h3.9c1.9,0,3,0.8,3,2.2c0,2-2.1,2.2-2.7,2.2h-4.2V791.5z     M-545.5,801.6h-4.2v-4.5h4.5c1.4,0,3.1,0.6,3.1,2.3C-542.2,801.4-544.5,801.6-545.5,801.6"
  }))), /*#__PURE__*/React.createElement("g", null, _defs55 || (_defs55 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_111_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_112_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_111_",
    style: {
      overflow: "visible"
    }
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M-528,794c0-1-0.3-1.8-0.9-2.4c-0.8-0.8-2-1.2-3.6-1.2h-5.1v12.4h1.2v-5h3.7l3.8,5h1.5l-3.9-5.1    C-529.3,797.3-528,796-528,794 M-536.5,796.6v-5h3.9c2.2,0,3.4,0.9,3.4,2.5s-1.3,2.5-3.5,2.5H-536.5z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs56 || (_defs56 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_113_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_114_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_113_",
    style: {
      overflow: "visible"
    }
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -524.4,
    y: 790.4,
    className: "st55",
    width: 1.2,
    height: 12.4
  }))), /*#__PURE__*/React.createElement("g", null, _defs57 || (_defs57 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_115_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_116_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_115_",
    style: {
      overflow: "visible"
    }
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "st56",
    points: "-518.1,790.4 -519.3,790.4 -519.3,802.8 -511,802.8 -511,801.6 -518.1,801.6   "
  }))), /*#__PURE__*/React.createElement("g", null, _defs58 || (_defs58 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_117_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_118_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_117_",
    style: {
      overflow: "visible"
    }
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M-498.4,790.4h-4.1v12.4h4.1c3.8,0,6.5-2.6,6.5-6.2C-491.8,793-494.6,790.4-498.4,790.4 M-498.4,801.6h-3    v-10.1h2.9c3.1,0,5.4,2.1,5.4,5.1C-493,799.5-495.3,801.6-498.4,801.6"
  }))), /*#__PURE__*/React.createElement("g", null, _defs59 || (_defs59 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_119_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_120_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_119_",
    style: {
      overflow: "visible"
    }
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "st58",
    points: "-487.3,797.1 -480.3,797.1 -480.3,796 -487.3,796 -487.3,791.5 -479.6,791.5 -479.6,790.4     -488.5,790.4 -488.5,802.8 -479.5,802.8 -479.5,801.6 -487.3,801.6   "
  }))), /*#__PURE__*/React.createElement("g", null, _defs60 || (_defs60 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_121_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_122_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_121_",
    style: {
      overflow: "visible"
    }
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "st59",
    points: "-471.8,791.6 -471.3,792.6 -469.4,791.8 -469.4,802.8 -468.2,802.8 -468.2,790.3 -469,790.3   "
  }))), /*#__PURE__*/React.createElement("g", null, _defs61 || (_defs61 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_123_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_124_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_123_",
    style: {
      overflow: "visible"
    }
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M-460.4,790.2c-2.5,0-4.4,1.8-4.4,4.2c0,2.3,1.9,4,4.4,4c1.4,0,2.6-0.6,3.4-1.6c-0.1,2.6-1.3,5-3.7,5    c-1,0-2-0.5-2.8-1.3l-0.3-0.3l-0.8,0.9l0.3,0.3c1,1,2.3,1.6,3.6,1.6c3,0,4.9-2.7,4.9-6.7c0-2.2-0.5-3.7-1.5-4.7    C-458.1,790.6-459.2,790.2-460.4,790.2 M-460.4,797.2c-1.9,0-3.3-1.2-3.3-2.9c0-1.6,1.5-3,3.2-3c1.8,0,3.2,1.3,3.2,3.1    C-457.2,796-458.6,797.2-460.4,797.2"
  }))), /*#__PURE__*/React.createElement("g", null, _defs62 || (_defs62 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_125_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_126_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_125_",
    style: {
      overflow: "visible"
    }
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M-447.6,797.6c2-1.9,2.3-2.9,2.3-4.1c0-1.9-1.6-3.3-3.8-3.3c-1.8,0-3.4,1-4.3,2.7l-0.2,0.4l1,0.6l0.2-0.4    c0.5-1,1.5-2.1,3.2-2.1c1.5,0,2.6,1,2.6,2.2c0,0.6-0.2,1.5-1.9,3.2l-5.4,5.2v0.8h8.6v-1.2h-6.6L-447.6,797.6z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs63 || (_defs63 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_127_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_128_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_127_",
    style: {
      overflow: "visible"
    }
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st62",
    d: "M-438.4,795.1c-0.9,0-1.7,0.1-2.5,0.4l0.2-4h5.8v-1.2h-7l-0.4,6.3l0.6,0.3l0.2-0.1c0.9-0.5,1.8-0.7,2.9-0.7    c1.8,0,3.1,1.1,3.1,2.7c0,1.7-1.3,2.9-3.2,2.9c-1.5,0-2.7-0.8-3.4-1.6l-0.3-0.3l-0.9,0.8l0.3,0.3c0.8,1,2.5,2,4.3,2    c2.5,0,4.4-1.7,4.4-4.1C-434.1,796.7-435.9,795.1-438.4,795.1"
  }))), /*#__PURE__*/React.createElement("g", null, _defs64 || (_defs64 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_129_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_130_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_129_",
    style: {
      overflow: "visible"
    }
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "M-442.5,800.7l0.3-0.2c0.8,1,2.2,1.8,3.7,1.8c2.1,0,3.6-1.4,3.6-3.3l0,0c0-1.8-1.6-3.1-3.5-3.1    c-0.9,0-2,0.2-3.1,0.8l-0.2-0.1l0.3-5.7h6.2v0.3h-5.8l-0.3,5c0.9-0.4,1.9-0.6,2.9-0.6c2.2,0,3.9,1.4,3.9,3.4l0,0    c0,2.1-1.6,3.6-4,3.6C-440.1,802.6-441.6,801.7-442.5,800.7"
  }))), /*#__PURE__*/React.createElement("g", null, _defs65 || (_defs65 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_131_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_132_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_131_",
    style: {
      overflow: "visible"
    }
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st64",
    d: "M-767.7,732.1h-0.3c-3,0-5.4-1.3-7-3.8c-0.7-1.1-1-2.3-1-3.6v-14.6c0-3.4,1.8-5.7,5.5-7    c1-0.3,1.9-0.4,2.6-0.4c3.6,0,6.2,1.5,7.7,4.5c0.4,1.2,0.6,2.1,0.6,2.8v4.7l-1,0.1h-4.7l-0.1-1v-3.2c0-1.8-0.8-2.3-1.4-2.5    c-0.7-0.1-1-0.1-1.1-0.1c-1.1,0-1.8,0.4-2.2,1.3c0,0.1-0.2,0.5-0.2,1.3v13.5c0,1.8,0.8,2.3,1.4,2.5c0.6,0.1,0.9,0.1,1,0.1    c1.1,0,1.7-0.4,2.2-1.3c0-0.1,0.2-0.3,0.2-1.3V720l1-0.1h4.7l0.1,1v3.8c0,2.1-0.9,5-5,6.8C-765.7,732-766.8,732.1-767.7,732.1"
  }))), /*#__PURE__*/React.createElement("g", null, _defs66 || (_defs66 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_133_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_134_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_133_",
    style: {
      overflow: "visible"
    }
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "st65",
    points: "-744.9,731.8 -757.5,731.8 -757.6,730.8 -757.6,703.2 -756.6,703 -751.8,703 -751.6,704.1     -751.6,726.5 -744,726.5 -743.9,727.5 -743.9,731.7   "
  }))), /*#__PURE__*/React.createElement("g", null, _defs67 || (_defs67 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_135_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_136_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_135_",
    style: {
      overflow: "visible"
    }
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M-734.3,732h-0.2c-3.7,0-6.3-1.7-7.7-4.9c-0.3-0.9-0.4-1.7-0.4-2.5v-21.5l1-0.1h4.1l0.7,0.2l0.1,0.8v20    c0,1.8,0.8,2.3,1.3,2.5c0.4,0.1,0.8,0.2,1.1,0.2c1.2,0,1.9-0.5,2.3-1.6v-0.2c0-0.3,0-0.6,0-0.8v-20.9l1.1-0.1h4.1l0.6,0.2l0.1,0.8    v20.6c0,3.4-1.9,5.8-5.5,7.1C-732.7,731.9-733.6,732-734.3,732"
  }))), /*#__PURE__*/React.createElement("g", null, _defs68 || (_defs68 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_137_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_138_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_137_",
    style: {
      overflow: "visible"
    }
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M-723.3,731.8l-0.1-1.1v-27.6l1-0.1h7.8c3.1,0,5.3,1.7,6.6,5.1c0.4,1.3,0.5,2.3,0.5,3.3c0,2-0.5,3.8-1.5,5.3    c1.5,1.6,2.2,3.6,2.2,6.1v0.3c0,4.1-1.6,6.9-4.8,8.3c-0.9,0.3-1.7,0.5-2.5,0.5L-723.3,731.8L-723.3,731.8z M-715.7,726.4    c1.5,0,2.4-0.5,2.9-1.8c0.1-0.5,0.2-0.9,0.2-1.3v-0.5c0-1.6-0.7-2.5-2.1-3c-0.1,0-0.2,0-0.3,0h-2.5v6.5L-715.7,726.4L-715.7,726.4    z M-715.7,714.3c0.4,0,1.4,0,2.1-1.9c0.1-0.3,0.2-0.7,0.2-1.1c0-2-1-2.7-1.7-3c-0.3-0.1-0.8-0.1-1.4-0.1h-1v6.1H-715.7z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs69 || (_defs69 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_139_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_140_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_139_",
    style: {
      overflow: "visible"
    }
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st68",
    d: "M-686.8,732.1h-0.3c-3.5,0-6-1.5-7.5-4.5c-0.4-1.1-0.6-2.1-0.6-2.9v-2.5l1-0.1h4.7l0.1,1v1.1    c0,1.9,0.7,2.6,2.4,2.6c1.1,0,2.3-0.4,2.3-3c0-1.7-2.3-3.1-4.3-4c-4.2-2.1-6.3-5.1-6.3-8.9c0-3.7,1.7-6.3,5-7.7    c1.1-0.3,2-0.4,2.8-0.4h0.3c3.2,0,5.7,1.5,7.2,4.4c0.4,1,0.6,2,0.6,2.9v2.6l-1,0.1h-4.6l-0.1-1v-1.4c0-1.3-0.5-2-1.8-2.3    c-0.1,0-0.3,0-0.4,0c-0.8,0-1.6,0.2-2,1.9c0,0.1,0,0.2,0,0.4v0.3c0,1.1,1.5,2.5,4.2,3.9c3.2,2,5.1,3.9,5.8,5.9    c0.4,1,0.5,2.1,0.5,3.2v0.4c0,3.8-1.8,6.4-5.4,7.8C-685.3,732-686.1,732.1-686.8,732.1"
  }))), /*#__PURE__*/React.createElement("g", null, _defs70 || (_defs70 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_141_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_142_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_141_",
    style: {
      overflow: "visible"
    }
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M-669.6,732.1c-3.1,0-5.4-1.3-7-3.8c-0.7-1.2-1-2.4-1-3.6v-14.6c0-2.3,1-5.4,5.5-7c1.1-0.3,1.9-0.4,2.6-0.4    h0.2c3.4,0,6,1.5,7.5,4.5c0.4,1.3,0.6,2.1,0.6,2.8v14.8c0,3.1-1.7,5.4-5,6.8c-1.1,0.3-2.1,0.5-3.1,0.5H-669.6L-669.6,732.1z     M-669.5,708.1c-1.1,0-1.7,0.4-2.2,1.3c-0.1,0.2-0.2,0.4-0.2,1.3v13.5c0,1.8,0.7,2.6,2.5,2.6c1,0,1.7-0.4,2.1-1.3    c0,0,0.1-0.3,0.1-1.3v-13.5c0-1.8-0.8-2.3-1.4-2.5C-668.9,708.1-669.3,708.1-669.5,708.1"
  }))), /*#__PURE__*/React.createElement("g", null, _defs71 || (_defs71 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_143_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_144_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_143_",
    style: {
      overflow: "visible"
    }
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st70",
    d: "M-651.3,732.1h-0.2c-3.1,0-5.4-1.3-7.1-3.8c-0.7-1.1-1-2.4-1-3.6v-14.6c0-3.4,1.8-5.7,5.5-7    c1-0.3,1.9-0.4,2.6-0.4h0.2c3.4,0,6,1.5,7.5,4.5c0.4,1.2,0.6,2.1,0.6,2.8v4.7l-1,0.1h-4.8l-0.1-1v-3.2c0-1.8-0.8-2.3-1.4-2.5    c-0.7-0.1-1-0.1-1-0.1c-1.1,0-1.8,0.4-2.2,1.3c-0.1,0.1-0.2,0.5-0.2,1.3v13.5c0,1.8,0.7,2.3,1.4,2.5c0.4,0.1,0.8,0.1,1,0.1    c1.1,0,1.8-0.4,2.2-1.3c0-0.1,0.2-0.3,0.2-1.3V720l1-0.1h4.7l0.1,1v3.8c0,3.1-1.7,5.4-5,6.8C-649.4,732-650.4,732.1-651.3,732.1"
  }))), /*#__PURE__*/React.createElement("g", null, _defs72 || (_defs72 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_145_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_146_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_145_",
    style: {
      overflow: "visible"
    }
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M-636.6,731.8h-4.7l-0.1-1.1V704c0-0.6,0.5-1.1,1.1-1.1h3.8c0.6,0,1.1,0.5,1.1,1.1v26.7    C-635.5,731.4-636,731.8-636.6,731.8"
  }))), /*#__PURE__*/React.createElement("g", null, _defs73 || (_defs73 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_147_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_148_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_147_",
    style: {
      overflow: "visible"
    }
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st72",
    d: "M-620.4,731.8c-0.8,0-0.9-0.3-1.6-3.7c-0.1-0.3-0.2-0.8-0.5-2.1h-4.7c-1.2,5.1-1.2,5.1-1.3,5.3l-0.3,0.5    h-4.8l-0.7-0.6l0.1-0.6l6.3-27.2l0.5-0.4h0.3h4.4c0.9,0,1,0.8,1.3,2.1c0,0,2.6,11.1,5.9,25.5l0.1,0.5l-0.6,0.6l-0.4,0.1    L-620.4,731.8L-620.4,731.8z M-623.8,720.7c-0.4-1.9-0.8-3.4-1.1-4.7l-1.1,4.7H-623.8z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs74 || (_defs74 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_149_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_150_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_149_",
    style: {
      overflow: "visible"
    }
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st73",
    d: "M-600.7,731.8h-12.6l-0.1-1.1v-27l0.2-0.6l0.8-0.1h3.9c0.6,0,1.1,0.5,1.1,1v22.4h7.6l0.1,1v4.2L-600.7,731.8    z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs75 || (_defs75 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_151_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_152_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_151_",
    style: {
      overflow: "visible"
    }
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st74",
    d: "M-583.2,731.8l-0.1-1.1v-11.3c-0.5-1.4-2.9-7.1-6.2-15.1l-0.4-0.9l1-0.4l0.3-0.1h4.4l0.3,0.4    c0.4,0.6,2.1,4.9,3.5,8.3c2.6-6.4,3.3-8,3.6-8.4l0.3-0.4h4.5l1,0.5l-0.2,0.9c-4.8,11.6-6,14.5-6.2,15.1v12.3l-1,0.1h-4.8V731.8z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs76 || (_defs76 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_153_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_154_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_153_",
    style: {
      overflow: "visible"
    }
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st75",
    d: "M-560.7,731.8l-0.1-1.1v-27.6l1-0.1h8.1c3,0,5.4,1.6,6.9,4.8c0.4,1,0.5,1.9,0.5,2.7v13.7    c0,3-1.5,5.3-4.5,6.9c-1.2,0.4-2.1,0.6-2.9,0.6h-9V731.8z M-552.4,726.5c1.1,0,1.8-0.4,2.2-1.3c0.1-0.3,0.2-0.7,0.2-1.2v-12.8    c0-1.8-0.8-2.3-1.4-2.6c-0.2,0-0.6-0.1-1-0.1h-2.6v18.1L-552.4,726.5L-552.4,726.5z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs77 || (_defs77 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_155_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_156_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_155_",
    style: {
      overflow: "visible"
    }
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "st76",
    points: "-529.4,731.8 -542.6,731.8 -542.8,730.8 -542.8,703.2 -541.7,703 -528.5,703 -528.4,704.1     -528.4,708.3 -529.4,708.4 -536.8,708.4 -536.8,714.7 -530.7,714.7 -530.6,715.8 -530.6,720 -531.6,720.1 -536.8,720.1     -536.8,726.5 -528.5,726.5 -528.4,727.5 -528.4,731.7   "
  }))), /*#__PURE__*/React.createElement("g", null, _defs78 || (_defs78 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_157_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_158_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_157_",
    style: {
      overflow: "visible"
    }
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st77",
    d: "M-526.6,731.8l-0.1-1.1v-27.6l1-0.1h7.9c3.3,0,5.7,1.7,7.1,5.1c0.4,1.2,0.7,2.5,0.7,3.8v0.2    c0,4-1.5,6.8-4.5,8.4c-0.9,0.5-2.1,0.7-3.7,0.7h-2.5v10.4l-1,0.1h-4.9V731.8z M-518.9,715.7c1.4,0,2.3-0.6,2.7-2    c0,0,0.1-0.4,0.3-1.6c0-1.7-0.7-2.8-2.1-3.4c-0.2,0-0.4-0.1-0.5-0.1h-2.2v7L-518.9,715.7L-518.9,715.7z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs79 || (_defs79 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_159_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_160_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_159_",
    style: {
      overflow: "visible"
    }
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st78",
    d: "M-500.4,732.1c-3.1,0-5.4-1.3-7.1-3.8c-0.7-1.2-1-2.4-1-3.7V710c0-2.3,1-5.4,5.5-7c1-0.3,1.9-0.4,2.6-0.4    h0.2c3.4,0,5.9,1.5,7.5,4.5c0.4,1.2,0.6,2.1,0.6,2.8v14.8c0,3.1-1.7,5.4-5,6.8c-1.1,0.3-2.1,0.5-3.1,0.5h-0.2V732.1z     M-500.2,708.1c-1.1,0-1.8,0.4-2.2,1.3c-0.1,0.1-0.2,0.5-0.2,1.3v13.5c0,1.8,0.7,2.6,2.5,2.6c1,0,1.7-0.4,2.1-1.3    c0.1-0.1,0.2-0.5,0.2-1.3v-13.5c0-1.8-0.8-2.3-1.4-2.5C-499.6,708.1-500,708.1-500.2,708.1"
  }))), /*#__PURE__*/React.createElement("g", null, _defs80 || (_defs80 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_161_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_162_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_161_",
    style: {
      overflow: "visible"
    }
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st79",
    d: "M-478.5,731.8c-0.6,0-1.1-0.5-1.1-1.1v-7.6c0-0.7-0.2-1.4-0.6-1.9c-0.2,0-0.4,0-0.5,0h-2.9v10.4l-1.1,0.1    h-4.7l-0.1-1.1V703l1-0.1h7.9c3.3,0,5.8,1.8,7.1,5.1c0.5,1.2,0.7,2.5,0.7,3.8v0.4c0,2.6-0.8,4.7-2.3,6.5c1,0.9,1.5,2.2,1.5,3.7    v9.2l-1.1,0.1h-3.8V731.8z M-481.8,715.7c1.4,0,2.3-0.6,2.7-2c0-0.1,0.2-0.4,0.3-1.6c0-1.7-0.7-2.8-2.1-3.4c-0.1,0-0.4,0-0.6,0    h-2.2v7H-481.8z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs81 || (_defs81 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_163_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_164_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_163_",
    style: {
      overflow: "visible"
    }
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "st80",
    points: "-461.3,731.8 -466.1,731.8 -466.2,730.8 -466.2,708.4 -471.8,708.4 -471.9,707.3 -471.9,703.2     -470.9,703 -454.6,703 -454.5,704.1 -454.5,708.3 -455.5,708.4 -460.3,708.4 -460.3,731.7   "
  }))), /*#__PURE__*/React.createElement("g", null, _defs82 || (_defs82 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_165_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_166_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_165_",
    style: {
      overflow: "visible"
    }
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M-448.3,731.8h-4.7l-0.1-1.1v-27.6l1.1-0.1h3.8c0.6,0,1.1,0.5,1.1,1.1v26.7    C-447.3,731.4-447.7,731.8-448.3,731.8"
  }))), /*#__PURE__*/React.createElement("g", null, _defs83 || (_defs83 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_167_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_168_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_167_",
    style: {
      overflow: "visible"
    }
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st82",
    d: "M-438.2,731.8c-0.9,0-0.9-0.1-2.1-5.4l-0.2-1c-0.7-3-2.4-10.1-5-21.2l-0.2-0.7l0.9-0.4l0.3-0.1h3.9    c0.9,0,0.9,0.2,2,5.1c0.1,0.5,0.6,2.2,2.3,10c2.2-9.6,3.1-13.6,3.4-14.4l0.2-0.7h4.9l0.8,0.5l-0.1,0.7l-3.5,15.2    c-1.8,7.7-2.6,11.3-2.7,11.7l-0.2,0.7L-438.2,731.8L-438.2,731.8z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs84 || (_defs84 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_169_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_170_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_169_",
    style: {
      overflow: "visible"
    }
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M-417.5,732.1c-3,0-5.4-1.3-7.1-3.8c-0.7-1.2-1-2.4-1-3.7V710c0-3.4,1.8-5.7,5.5-7c1-0.3,1.8-0.4,2.6-0.4    c3.6,0,6.1,1.5,7.7,4.5c0.4,1.2,0.6,2,0.6,2.8v14.8c0,3.1-1.7,5.4-5,6.8c-1.1,0.3-2.1,0.5-3.1,0.5h-0.2V732.1z M-417.4,708.1    c-1.1,0-1.7,0.4-2.2,1.3c-0.1,0.1-0.2,0.4-0.2,1.3v13.5c0,1.8,0.7,2.6,2.5,2.6c1,0,1.7-0.4,2.1-1.3c0.1-0.1,0.1-0.5,0.1-1.3v-13.5    c0-1.8-0.7-2.3-1.4-2.5C-416.8,708.1-417.2,708.1-417.4,708.1"
  }))), /*#__PURE__*/React.createElement("g", null, _defs85 || (_defs85 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_171_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_172_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_171_",
    style: {
      overflow: "visible"
    }
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st84",
    d: "M-659.6,771h-0.2c-3,0-5.4-1.3-7-3.8c-0.7-1.2-1-2.4-1-3.6V749c0-2.3,0.9-5.4,5.5-7c0.9-0.2,1.8-0.4,2.6-0.4    c3.6,0,6.2,1.6,7.7,4.5c0.4,1.1,0.6,2,0.6,2.8v4.7l-1,0.1h-4.7l-0.1-1v-3.1c0-1.8-0.8-2.3-1.4-2.5c-0.6-0.1-0.9-0.1-1-0.1    c-1.1,0-1.8,0.4-2.2,1.3c0,0.1-0.2,0.4-0.2,1.3v13.5c0,1.8,0.8,2.3,1.4,2.5c0.4,0.1,0.8,0.1,1,0.1c1.1,0,1.8-0.4,2.2-1.3    c0-0.1,0.2-0.3,0.2-1.3V759l1-0.1h4.7l0.1,1v3.8c0,3.1-1.7,5.4-5,6.8C-657.6,770.8-658.6,771-659.6,771"
  }))), /*#__PURE__*/React.createElement("g", null, _defs86 || (_defs86 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_173_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_174_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_173_",
    style: {
      overflow: "visible"
    }
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st85",
    d: "M-641.5,770.9c-3,0-5.4-1.3-7.1-3.7c-0.7-1.2-1-2.4-1-3.7v-14.6c0-2.3,1-5.4,5.5-7c1-0.2,1.8-0.4,2.6-0.4    c3.6,0,6.2,1.5,7.7,4.5c0.4,1.1,0.6,2,0.6,2.8v14.8c0,3.1-1.7,5.4-5,6.8c-1.1,0.3-2.1,0.5-3.1,0.5H-641.5z M-641.4,746.8    c-1.1,0-1.8,0.4-2.2,1.3c0,0.1-0.2,0.3-0.2,1.3v13.5c0,1.8,0.7,2.6,2.5,2.6c1,0,1.7-0.4,2.1-1.3c0,0,0.2-0.4,0.2-1.3v-13.5    c0-1.8-0.8-2.3-1.4-2.5C-640.9,746.9-641.3,746.8-641.4,746.8"
  }))), /*#__PURE__*/React.createElement("g", null, _defs87 || (_defs87 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_175_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_176_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_175_",
    style: {
      overflow: "visible"
    }
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "st86",
    points: "-618.6,770.6 -631.2,770.6 -631.3,769.6 -631.3,741.9 -630.2,741.8 -626,741.9 -625.4,742.1     -625.3,742.9 -625.3,765.3 -617.7,765.3 -617.6,766.3 -617.6,770.5   "
  }))), /*#__PURE__*/React.createElement("g", null, _defs88 || (_defs88 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_177_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_178_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_177_",
    style: {
      overflow: "visible"
    }
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M-608.4,770.9c-3.1,0-5.4-1.3-7.1-3.7c-0.7-1.2-1-2.4-1-3.7v-14.6c0-2.3,1-5.4,5.5-7    c0.9-0.2,1.8-0.4,2.6-0.4h0.2c3.4,0,6,1.5,7.5,4.5c0.4,1.1,0.6,2,0.6,2.8v14.8c0,3.1-1.7,5.4-5,6.8c-1.1,0.3-2.1,0.5-3.1,0.5    H-608.4z M-608.3,746.8c-1.1,0-1.7,0.4-2.2,1.3c0,0-0.2,0.3-0.2,1.3v13.5c0,1.8,0.7,2.6,2.5,2.6c1,0,1.7-0.4,2.1-1.3    c0.1-0.1,0.1-0.6,0.1-1.3v-13.5c0-1.8-0.8-2.3-1.4-2.5C-607.7,746.9-608.1,746.8-608.3,746.8"
  }))), /*#__PURE__*/React.createElement("g", null, _defs89 || (_defs89 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_179_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_180_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_179_",
    style: {
      overflow: "visible"
    }
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st88",
    d: "M-576.9,771h-0.2c-3,0-5.4-1.3-7-3.8c-0.7-1.2-1-2.4-1-3.6V749c0-2.3,0.9-5.4,5.5-7c0.9-0.2,1.8-0.4,2.6-0.4    c3.6,0,6.2,1.6,7.7,4.5c0.4,1.1,0.6,2,0.6,2.8v4.7l-1,0.1h-4.7l-0.1-1v-3.1c0-1.8-0.8-2.3-1.4-2.5c-0.6-0.1-0.9-0.1-1-0.1    c-1.1,0-1.8,0.4-2.2,1.3c0,0.1-0.2,0.4-0.2,1.3v13.5c0,1.8,0.8,2.3,1.4,2.5c0.4,0.1,0.8,0.1,1,0.1c1.1,0,1.8-0.4,2.2-1.3    c0-0.1,0.2-0.3,0.2-1.3V759l1-0.1h4.7l0.1,1v3.8c0,3.1-1.7,5.4-5,6.8C-574.9,770.8-575.9,771-576.9,771"
  }))), /*#__PURE__*/React.createElement("g", null, _defs90 || (_defs90 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_181_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_182_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_181_",
    style: {
      overflow: "visible"
    }
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M-558.8,770.9c-3,0-5.4-1.3-7.1-3.7c-0.7-1.2-1-2.4-1-3.7v-14.6c0-2.3,1-5.4,5.5-7c1-0.2,1.8-0.4,2.6-0.4    c3.6,0,6.2,1.5,7.7,4.5c0.4,1.1,0.6,2,0.6,2.8v14.8c0,3.1-1.7,5.4-5,6.8c-1.1,0.3-2.1,0.5-3.1,0.5H-558.8z M-558.6,746.8    c-1.1,0-1.8,0.4-2.2,1.3c0,0.1-0.2,0.3-0.2,1.3v13.5c0,1.8,0.7,2.6,2.5,2.6c1,0,1.7-0.4,2.1-1.3c0,0,0.2-0.4,0.2-1.3v-13.5    c0-1.8-0.8-2.3-1.4-2.5C-558.1,746.9-558.5,746.8-558.6,746.8"
  }))), /*#__PURE__*/React.createElement("g", null, _defs91 || (_defs91 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_183_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_184_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_183_",
    style: {
      overflow: "visible"
    }
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "st90",
    points: "-535.9,770.6 -548.4,770.6 -548.5,769.6 -548.5,741.9 -547.5,741.8 -543.3,741.9 -542.7,742.1     -542.6,742.9 -542.6,765.3 -534.9,765.3 -534.8,766.3 -534.8,770.5   "
  }))), /*#__PURE__*/React.createElement("g", null, _defs92 || (_defs92 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_185_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_186_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_185_",
    style: {
      overflow: "visible"
    }
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "M-525.6,770.9c-3.1,0-5.4-1.3-7.1-3.7c-0.7-1.2-1-2.4-1-3.7v-14.6c0-2.3,1-5.4,5.5-7    c0.9-0.2,1.8-0.4,2.6-0.4h0.2c3.4,0,6,1.5,7.5,4.5c0.4,1.1,0.6,2,0.6,2.8v14.8c0,3.1-1.7,5.4-5,6.8c-1.1,0.3-2.1,0.5-3.1,0.5    H-525.6z M-525.5,746.8c-1.1,0-1.7,0.4-2.2,1.3c0,0-0.2,0.3-0.2,1.3v13.5c0,1.8,0.7,2.6,2.5,2.6c1,0,1.7-0.4,2.1-1.3    c0.1-0.1,0.1-0.6,0.1-1.3v-13.5c0-1.8-0.8-2.3-1.4-2.5C-525,746.9-525.3,746.8-525.5,746.8"
  }))), /*#__PURE__*/React.createElement("g", null, _defs93 || (_defs93 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_187_",
    x: -776,
    y: 279.6,
    width: 366.8,
    height: 523.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_188_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_187_",
    style: {
      overflow: "visible"
    }
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "st92",
    points: "-589.2,759.9 -597.1,759.9 -597.1,758.9 -597.1,754.1 -596.1,753.9 -589.2,753.9 -588.9,754.6     -588.8,755 -588.8,759.1   "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c0842a7a2a5456707b3a2561bff13c0d.svg";
export { ForwardRef as ReactComponent };